export default "__VITE_ASSET__G2rmWpM8__"